<template>
    <page>
		<module enable-flex>
			<m-operate>
				<c-button color="sys" power="b_system_menu_edit" icon="add" @click="addHandle()">新增一级菜单</c-button>
				<c-button color="gray" hollow power="b_basicinfo_address_library_add" @click="saveHandle">全部保存</c-button>
			</m-operate>
			
			<c-table ref="table" :paging="false">
				<c-table-column
					type="expand"
					label="菜单名称"
					name="menu_name"
					:expand-button="isMenu"
					:add-button="addButton"
					expand-limit="3"
					width="250"
					@expand="loadChildren"
					@add="addHandle"
				>
					<template v-slot="row">
						<input v-model="row.data.menu_name" @change="editHandle(row)"/>
					</template>
				</c-table-column>
				
				<c-table-column
					label="图标"
					width="150"
				>
					<template v-slot="row">
						<input v-if="row.expandData.level == 0" v-model="row.data.menu_ico" @change="editHandle(row)"/>
					</template>
				</c-table-column>
				
				<c-table-column
					label="别名"
					width="150"
				>
					<template v-slot="row">
						<input v-model="row.data.menu_subname" @change="editHandle(row)"/>
					</template>
				</c-table-column>
				
				<c-table-column
					label="页面key"
					name="menu_unique_key"
					width="250"
				></c-table-column>
				
				<c-table-column
					type="sort"
					label="排序"
					@sort="sortHandle"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="120"
				>
					<template v-slot="row">
						<c-table-button v-if="row.data.menu_type == 2" @click="moveHandle(row)">移动</c-table-button>
						<c-table-button v-else @click="deleteHandle(row)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="dialog" width="400" title="移动至菜单" @resolve="moveResolveHandle">
			<c-tree ref="tree" :props="{'name': 'menu_name'}" :leading="false" :load="loadTree" height="500"></c-tree>
		</c-dialog>
	</page>
</template>

<script>
	import cTree from '@/components/unit/tree.vue'
	
	export default {
		name: 'm_system_menu',
		
		components: {
			cTree
		},
		
		data() {
			return {
				dataList: []
			}
		},
		
		mounted() {
			this.update();
		},
		
		methods: {
			update() {
				this.$refs.table.load({
					url: '/system_menu/get_sub_menu',
					data: {
						menu_id: 1
					}
				});
			},
			
			isMenu(row) {
				return row.data.menu_type == 1;
			},
			
			loadChildren(row, resolve, reject) {
				if (!row.data.id) {
					this.$message({
						text: '请先保存新增菜单'
					});
					reject();
					return;
				}
				
				this.request({
					url: '/system_menu/get_sub_menu',
					data: {
						menu_id: row.data.id
					},
					success: data => {
						resolve(data || []);
					}
				});
			},
			
			addButton(row) {
				return row.expandData.level == 0 ? '添加子菜单' : false;
			},
			
			addHandle(row, resolve) {
				var list = row ? row.expandData.children : this.$refs.table.getRow(),
					data = {
						id: '',
						menu_name: '',
						menu_ico: '',
						menu_subname: '',
						menu_unique_key: '',
						sort_id: list.length + 1,
						editFlag: true,
						newFlag: true
					};
				
				if (row) {
					resolve(data);
					row.data.childEditFlag = true;
				} else {
					this.$refs.table.push(data);
				}
			},
			
			editHandle(row) {
				row.data.editFlag = true;
				
				var parent = row.expandData.parent;
				if (!parent.expandData.parent || !parent.expandData.parent.data.childEditFlag) {
					parent.data.childEditFlag = true;
				}
			},
			
			saveHandle() {
				var list = this.$refs.table.getRow(item => item.data.editFlag);
				
				if (!list.length) {
					this.$message({
						text: '您还未编辑任何数据'
					});
					return;
				}
				
				this.request({
					url: '/system_menu/save_all',
					data: {
						first_menu_id: 1,
						menu_list: Array.from(list, item => {
							return {
								parent_id: item.expandData.parent ? item.expandData.parent.data.id : 1,
								id: item.data.id || 0,
								menu_name: item.data.menu_name,
								menu_subname: item.data.menu_subname,
								menu_ico: item.data.menu_ico,
								sort_id: item.data.sort_id
							}
						})
					},
					loading: true,
					success: data => {
						this.$message({
							text: '保存成功'
						});
						
						if (list.find(item => !item.expandData.parent)) {
							this.update();
						} else {
							this.$refs.table.getRow(item => item.data.childEditFlag).forEach(item => {
								item.data.childEditFlag = false;
								item.load();
							});
						}
					}
				});
			},
			
			sortHandle(row, type, next) {
				if (this.hasUnsaved()) {
					this.$message({
						text: '请先保存新增和已编辑的菜单'
					});
					return;
				}
				
				next();
				var list = row.expandData.parent ? row.expandData.parent.expandData.children : this.$refs.table.getRow();
				this.request({
					url: '/system_menu/sort',
					data: {
						menu_list: Array.from(list, (item, index) => {
							return {
								id: item.data.id,
								sort_id: index + 1
							}
						})
					},
					loading: true,
					fail: () => {
						this.update();
					}
				});
			},
			
			hasUnsaved() {
				return this.$refs.table.getRow(item => {
					return item.data.editFlag;
				}).length;
			},
			
			deleteHandle(row) {
				if (row.data.has_child) {
					this.$message({
						text: '请先移动或删除该菜单下<br>所有子菜单'
					});
					return;
				}
				
				this.$confirm({
					text: '确定要删除此菜单吗？',
					resolve: () => {
						if (row.data.newFlag) {
							row.remove();
							return;
						}
						
						this.request({
							url: '/system_menu/del',
							data: {
								id: row.data.id
							},
							loading: true,
							success: data => {
								this.$message({
									text: '删除成功'
								});
								row.remove();
							}
						});
					}
				});
			},
			
			moveHandle(row) {
				if (this.hasUnsaved()) {
					this.$message({
						text: '请先保存新增和已编辑的菜单'
					});
					return;
				}
				
				this._move = row;
					
				this.$refs.tree.update();
				this.$refs.dialog.open();
			},
			
			loadTree(node, resolve) {
				this.request({
					url: '/system_menu/get_sub_menu',
					data: {
						menu_id: node ? node.data.id : 1
					},
					success: data => {
						data = data.filter(item => item.menu_type == 1);
						if (node) {
							data.forEach(item => {
								item.leaf = true;
							});
						}
						resolve(data);
					}
				});
			},
			
			moveResolveHandle(stop) {
				stop();
				var target = this.$refs.tree.getNode('selected');
				this.request({
					url: '/system_menu/move',
					data: {
						id: this._move.data.id,
						target_id: target.data.id
					},
					loading: true,
					success: data => {
						this.$refs.dialog.close();
						this._move.remove();
						this.$refs.table.getRow(item => item.data.id == target.data.id)[0].load();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.menu-link {
		padding: 2px 5px;
		border: 1px solid #fff;
		text-decoration: underline;
		
		&.z-crt {
			border-color: #FFB951;;
			background: #FFE6B0;
		}
	}
</style>